import { useState, useEffect } from 'react';

const useScrollPosition = () => {
  const [position, setPosition] = useState({
    x: window.scrollX,
    y: window.scrollY
  });

  useEffect(() => {
    const handleScroll = () =>
      setPosition({
        x: window.scrollX,
        y: window.scrollY
      });

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return position;
};

export default useScrollPosition;
